(() => {
  const SECTION_SELECTOR = '.oddit-section-faq';
  const ITEM_SELECTOR = '[data-faq-item]';
  const TRIGGER_SELECTOR = '[data-faq-trigger]';
  const ANSWER_SELECTOR = '[data-faq-answer]';

  const CHEVRON_UP = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 10L8 6L4 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  const CHEVRON_DOWN = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function toggleItem(item, forceOpen) {
    const trigger = item.querySelector(TRIGGER_SELECTOR);
    const answer = item.querySelector(ANSWER_SELECTOR);
    if (!trigger || !answer) return;

    const icon = trigger.querySelector('.oddit-section-faq__icon');
    if (!icon) return;

    const isCurrentlyOpen = trigger.getAttribute('aria-expanded') === 'true';
    const shouldOpen = typeof forceOpen === 'boolean' ? forceOpen : !isCurrentlyOpen;

    trigger.setAttribute('aria-expanded', String(shouldOpen));
    answer.setAttribute('aria-hidden', String(!shouldOpen));

    if (shouldOpen) {
      answer.removeAttribute('hidden');
      icon.classList.add('oddit-section-faq__icon--active');
      icon.innerHTML = CHEVRON_UP;
    } else {
      answer.setAttribute('hidden', '');
      icon.classList.remove('oddit-section-faq__icon--active');
      icon.innerHTML = CHEVRON_DOWN;
    }
  }

  function handleClick(e) {
    const trigger = e.target.closest(TRIGGER_SELECTOR);
    if (!trigger) return;

    const item = trigger.closest(ITEM_SELECTOR);
    if (!item) return;

    const section = item.closest(SECTION_SELECTOR);
    if (!section) return;

    const isOpen = trigger.getAttribute('aria-expanded') === 'true';

    // Close all other items in this section
    for (const otherItem of section.querySelectorAll(ITEM_SELECTOR)) {
      if (otherItem !== item) {
        toggleItem(otherItem, false);
      }
    }

    // Toggle the clicked item
    toggleItem(item, !isOpen);
  }

  function initSection(section) {
    section.addEventListener('click', handleClick);
  }

  function destroySection(section) {
    section.removeEventListener('click', handleClick);
  }

  for (const section of document.querySelectorAll(SECTION_SELECTOR)) {
    initSection(section);
  }

  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();